import { environment as baseEnv } from './environment.base';

export const environment = {
  ...baseEnv,
  production: true,
  name: 'prd',
  api: {
    url: 'https://betbooks.gr:8080',
  },
  // Override Google Analytics ID for production (set to null to disable)
  googleAnalyticsId: 'G-SP2V1E7CDP', // Web tracking ID
};
